import { render, staticRenderFns } from "./ViewAll.vue?vue&type=template&id=537b7d38&scoped=true&"
import script from "./ViewAll.vue?vue&type=script&lang=js&"
export * from "./ViewAll.vue?vue&type=script&lang=js&"
import style0 from "./ViewAll.vue?vue&type=style&index=0&id=537b7d38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b7d38",
  null
  
)

export default component.exports